import { Stepper } from '../../../../components/stepper';
import { FTUHelpCenter } from './ftu-help-center';
import { useScreenSizeContext } from '../../../../contexts/screen-size-resolution';
import { useFTUWizardContext } from './context/ftu-wizard-context';
import style from './style.module.less';

export const FTUWizardSidebar = ({ currentStepperStep, stepLabels, totalStepperSteps }) => {
  const { isMobile, isUltraMobile } = useScreenSizeContext();
  const isMobileOrSmaller = isMobile || isUltraMobile;
  const { isSetupWizardComplete } = useFTUWizardContext();

  const stepperCurrentStep = isSetupWizardComplete ? totalStepperSteps + 1 : currentStepperStep;

  return (
    <div className={style['ftu-wizard-progress']}>
      <div className={style['ftu-wizard-stepper']}>
        <Stepper currentStep={stepperCurrentStep} isHorizontal={isMobileOrSmaller} stepLabels={stepLabels} totalSteps={totalStepperSteps} />
      </div>
      <div className={style['ftu-wizard-help-center']}>
        <FTUHelpCenter />
      </div>
    </div>
  );
};
